module.exports = __webpack_public_path__ + "img/time-and-date.86d18d75.png";